(function () {
  var __landraRoot = document.querySelector(".landra-page-outer");
  if (!__landraRoot) return;
function attachCarouselControls(carousel) {
  var track = carousel.querySelector('.lc-tcar-track');
  if (!track) return function() {};
  var pages = Array.prototype.slice.call(carousel.querySelectorAll('.lc-tcar-page'));
  var dots = Array.prototype.slice.call(carousel.querySelectorAll('.lc-tcar-dot'));
  var prevBtn = carousel.querySelector('.lc-tcar-arr.prev');
  var nextBtn = carousel.querySelector('.lc-tcar-arr.next');
  if (pages.length === 0) return function() {};
  function pageStride() {
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return track.clientWidth + gap;
  }
  function currentPage() {
    var stride = pageStride();
    if (stride === 0) return 0;
    var raw = Math.round(track.scrollLeft / stride);
    return Math.max(0, Math.min(raw, pages.length - 1));
  }
  function syncUi() {
    var idx = currentPage();
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('on', i === idx);
      if (i === idx) {
        dots[i].setAttribute('aria-current', 'true');
      } else {
        dots[i].removeAttribute('aria-current');
      }
    }
    if (prevBtn) {
      prevBtn.classList.toggle('off', idx === 0);
      prevBtn.setAttribute('aria-disabled', idx === 0 ? 'true' : 'false');
    }
    if (nextBtn) {
      var atEnd = idx >= pages.length - 1;
      nextBtn.classList.toggle('off', atEnd);
      nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    }
  }
  function scrollToPage(idx) {
    var clamped = Math.max(0, Math.min(idx, pages.length - 1));
    track.scrollTo({ left: clamped * pageStride(), behavior: 'smooth' });
  }
  function onPrev(e) { e.preventDefault(); scrollToPage(currentPage() - 1); }
  function onNext(e) { e.preventDefault(); scrollToPage(currentPage() + 1); }
  function onKeydown(e) {
    if (e.key === 'ArrowLeft') { e.preventDefault(); scrollToPage(currentPage() - 1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); scrollToPage(currentPage() + 1); }
  }
  var scrollFrame = 0;
  function onScroll() {
    if (scrollFrame) cancelAnimationFrame(scrollFrame);
    scrollFrame = requestAnimationFrame(syncUi);
  }
  var dotHandlers = dots.map(function(_, i) {
    return function(e) { e.preventDefault(); scrollToPage(i); };
  });
  if (prevBtn) prevBtn.addEventListener('click', onPrev);
  if (nextBtn) nextBtn.addEventListener('click', onNext);
  dots.forEach(function(dot, i) { dot.addEventListener('click', dotHandlers[i]); });
  track.addEventListener('scroll', onScroll, { passive: true });
  carousel.addEventListener('keydown', onKeydown);
  if (!track.hasAttribute('tabindex')) track.setAttribute('tabindex', '0');
  syncUi();
  return function cleanup() {
    if (scrollFrame) cancelAnimationFrame(scrollFrame);
    if (prevBtn) prevBtn.removeEventListener('click', onPrev);
    if (nextBtn) nextBtn.removeEventListener('click', onNext);
    dots.forEach(function(dot, i) { dot.removeEventListener('click', dotHandlers[i]); });
    track.removeEventListener('scroll', onScroll);
    carousel.removeEventListener('keydown', onKeydown);
  };
}
function __landraInit() {
  // Run once even if the script is present twice (e.g. pasted into a CMS page
  // that already carries an export). Without this, FAQ handlers double-bind.
  if (window.__landraInitDone) return;
  window.__landraInitDone = true;
  // Each phase is isolated: one handler throwing must not block the rest. This
  // matters most for __landraPremiumAnims — the head script hides listicle items
  // before paint (.landra-anim), so if it never ran the page would stay blank.
  function safe(fn) {
    try {
      fn();
    } catch (e) {}
  }

  safe(function () {
    // FAQ accordion — legacy class
    __landraRoot.querySelectorAll('.faq-question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        this.classList.toggle('active');
        if (this.nextElementSibling) this.nextElementSibling.classList.toggle('active');
      });
    });
    // FAQ accordion — component library class. Sync aria-expanded alongside
    // the .op class so screen readers track the open/closed state. Mirrors
    // the editor-preview script in lib/html-post-processor.ts.
    __landraRoot.querySelectorAll('.lc-fq-q').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var item = this.closest('.lc-fq-i');
        if (item) {
          item.classList.toggle('op');
          this.setAttribute('aria-expanded', item.classList.contains('op') ? 'true' : 'false');
        }
      });
    });
  });

  safe(function () {
    // Fade-in animation
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      __landraRoot.querySelectorAll('.fade-in').forEach(function (el) {
        observer.observe(el);
      });
    } else {
      // Fallback: show all immediately
      __landraRoot.querySelectorAll('.fade-in').forEach(function (el) {
        el.classList.add('visible');
      });
    }
  });

  safe(function () {
    // Testimonial carousel — native scroll-snap, JS wires only arrow/dot/keyboard
    __landraRoot.querySelectorAll('.lc-tcar').forEach(function (carousel) {
      if (carousel.classList.contains('single')) return;
      attachCarouselControls(carousel);
    });
  });

  safe(__landraScrollbarWidth);
  safe(__landraCountdown);
  safe(__landraForwardParams);
  safe(__landraStickyBarOffset);
  safe(__landraStickyReveal);
  safe(__landraPremiumAnims);
  safe(__landraReviewWall);
  safe(__landraReasonsJump);
  safe(__landraBrandLogoFallback);
  safe(__landraSrcsetFallback);
}

// Responsive-image safety net: an <img> whose srcset candidate fails to load
// falls back to its plain src (the original file — exactly what the page
// served before srcset existed).
//
// The rendered candidates point at Supabase's image-transform endpoint, a
// SEPARATE service from object storage with its own failure modes: the
// feature can be toggled off in the dashboard, a plan's transform quota can
// exhaust mid-cycle, and per-image source limits (25MB / 50MP) can reject a
// file whose original serves fine. Browsers do NOT retry another srcset
// candidate or fall back to src on a load error — a failed candidate is a
// permanently broken image. Phones almost always pick a rendered candidate,
// and these are the money pages, so the failure mode without this is "every
// image broken for every phone visitor" from a config change nobody
// associates with pages that were fine yesterday.
//
// Removing srcset+sizes and re-setting src forces a reload from the original
// object URL, which is served by plain storage and unaffected by any
// transform-service state. Same both-timings pattern as the logo fallback
// (an already-failed image never re-fires 'error' at a late-bound listener).
function __landraSrcsetFallback() {
  __landraRoot.querySelectorAll('img[srcset]').forEach(function (img) {
    function fallback() {
      if (!img.hasAttribute('srcset')) return;
      var src = img.getAttribute('src');
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      if (src) img.setAttribute('src', src);
    }
    if (img.complete) {
      if (img.naturalWidth === 0) fallback();
    } else {
      img.addEventListener('error', fallback);
    }
  });
}

// Obsessed Listicle: a brand logo that fails to load falls back to the text
// wordmark instead of leaving a broken <img> in the header.
//
// The logo url is verified at generation time, but a live page outlives that
// check — brands re-theme and their asset urls rot (supermush.com's own
// declared logo already 404s). Without this, the browser paints a broken-image
// icon plus the alt text, which reads like a duplicated wordmark.
//
// Both timings are covered: an image that already failed before this ran is
// caught via complete/naturalWidth (a past 'error' event never re-fires at a
// listener bound after it), and one still in flight gets the listener.
function __landraBrandLogoFallback() {
  // Shared error hook: a resolved logo URL can die AFTER generation (Shopify
  // theme-asset paths rotate on theme updates), so every surface that renders
  // the brand logo needs a runtime swap to its wordmark treatment — a broken
  // image icon + alt text otherwise reads as a phantom duplicated wordmark.
  function onBroken(img, fallback) {
    if (img.complete) {
      if (img.naturalWidth === 0) fallback();
    } else {
      img.addEventListener('error', fallback);
    }
  }
  __landraRoot.querySelectorAll('.header-ob-logo').forEach(function (img) {
    onBroken(img, function () {
      var slot = img.parentElement;
      if (!slot) return;
      var header = img.closest('.header--obsessed-hero');
      var wordmark = header ? header.getAttribute('data-header-brand-wordmark') : '';
      if (wordmark) {
        // Drop the --logo modifier so the wordmark's own type styles apply.
        slot.classList.remove('header-ob-wordmark--logo');
        slot.textContent = wordmark;
      } else {
        slot.remove();
      }
    });
  });
  // Risk-free hero: same wordmark treatment, its own class names.
  __landraRoot.querySelectorAll('.header-rf-logo').forEach(function (img) {
    onBroken(img, function () {
      var slot = img.parentElement;
      if (!slot) return;
      var header = img.closest('[data-header-brand-wordmark]');
      var wordmark = header ? header.getAttribute('data-header-brand-wordmark') : '';
      if (!wordmark) wordmark = img.getAttribute('alt') || '';
      if (wordmark && wordmark !== 'Brand logo') {
        slot.classList.remove('header-rf-wordmark--logo');
        slot.textContent = wordmark;
      } else {
        slot.remove();
      }
    });
  });
  // Comparison table "us" column header: swap the broken logo for the dark
  // wordmark pill (the alt carries the brand label).
  __landraRoot.querySelectorAll('.lc-vt-uslogo').forEach(function (img) {
    onBroken(img, function () {
      var label = img.getAttribute('alt') || '';
      if (!label) {
        img.remove();
        return;
      }
      var pill = document.createElement('span');
      pill.className = 'lc-vt-uspill';
      pill.textContent = label;
      img.replaceWith(pill);
    });
  });
}

// Obsessed Listicle: the header "See the reasons ↓" link smooth-scrolls to the
// first numbered reason. No fragile #id anchor (section ids don't survive the
// editor roundtrip) — resolve the first offer-reason section at click time.
function __landraReasonsJump() {
  var links = __landraRoot.querySelectorAll('.header-ob-jump');
  if (!links.length) return;
  function scrollToReasons(e) {
    var target =
      __landraRoot.querySelector('[data-section^="offer-reason"]') || __landraRoot.querySelector('.lc-or');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  for (var i = 0; i < links.length; i++) {
    links[i].addEventListener('click', scrollToReasons);
  }
}

// Review wall "Show more": reveal the next data-step hidden cards per click;
// keep the remaining count in the label; drop the button when everything is
// visible. Cards are all pre-rendered in the DOM (SEO/indexability) — this
// only flips the .hid class.
function __landraReviewWall() {
  __landraRoot.querySelectorAll('.lc-rw').forEach(function (wall) {
    var button = wall.querySelector('.lc-rw-more');
    if (!button) return;
    button.addEventListener('click', function () {
      var step = parseInt(button.getAttribute('data-step') || '12', 10) || 12;
      var hidden = wall.querySelectorAll('.lc-rw-c.hid');
      for (var i = 0; i < hidden.length && i < step; i++) {
        hidden[i].classList.remove('hid');
      }
      var remaining = wall.querySelectorAll('.lc-rw-c.hid').length;
      if (remaining === 0) {
        button.remove();
      } else {
        button.textContent = 'Show more reviews (' + remaining + ')';
      }
    });
  });
}

// Publish the 100vw overshoot as --landra-sbw so full-bleed sections (which use
// calc(100vw - var(--landra-sbw)) — see lib/publish/full-bleed.ts) reach exactly
// the content edge instead of overshooting under the scrollbar and creating a
// phantom horizontal scrollbar. Measured DIRECTLY via a width:100vw probe element
// (probe width - clientWidth), NOT inferred from innerWidth - clientWidth: in
// DevTools device-emulation/responsive mode the innerWidth/clientWidth/100vw
// trio disagree (emulated visual-viewport semantics), so the inferred value
// insets or overflows the full-bleed — the probe measures the exact quantity the
// CSS subtracts, which is correct by construction in every context (real mobile,
// emulation, classic scrollbars, zoom). Re-measured on resize (scrollbar
// presence changes with content height/zoom; emulator drags fire resize).
// Defaults to 0px until this runs, so a scrollbar-less system (overlay
// scrollbars) needs no correction.
function __landraScrollbarWidth() {
  function set() {
    var de = document.documentElement;
    var probe = document.createElement('div');
    probe.style.cssText =
      'position:absolute;top:-9999px;left:0;width:100vw;height:1px;pointer-events:none;visibility:hidden;';
    de.appendChild(probe);
    var overshoot = probe.getBoundingClientRect().width - de.clientWidth;
    de.removeChild(probe);
    de.style.setProperty('--landra-sbw', (overshoot > 0 ? overshoot : 0) + 'px');
  }
  set();
  window.addEventListener('resize', set, { passive: true });
}

// Scroll-reveal for the mobile sticky CTA: keep it hidden until the visitor has
// scrolled ~2 viewport lengths, then reveal it (CSS fades/slides it in). One-way
// — once shown it stays. Only affects bars that opted in (.landra-sticky-reveal).
// Reads scroll progress from whichever element actually scrolls: the window on a
// normal page, or a popup/iframe's own inner container when the page is embedded
// (window scroll never fires there, so window.pageYOffset stays 0). The scroll
// listener is registered capture-phase so window receives scroll events dispatched
// to any nested scroller (scroll doesn't bubble, but it propagates on capture).
function __landraStickyReveal() {
  var bar = __landraRoot.querySelector('.landra-sticky-mobile-cta.landra-sticky-reveal');
  if (!bar) return;
  function scrolledPast(el) {
    var top, vh;
    if (!el || el === window || el === document || el === document.documentElement || el === document.body) {
      top = window.pageYOffset || document.documentElement.scrollTop || 0;
      vh = window.innerHeight || document.documentElement.clientHeight;
    } else {
      top = el.scrollTop;
      vh = el.clientHeight;
    }
    return top > vh * 2;
  }
  function onScroll(e) {
    if (scrolledPast(e && e.target)) {
      bar.classList.add('is-revealed');
      window.removeEventListener('scroll', onScroll, true);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true, capture: true });
  // Handle a load already scrolled past the threshold (refresh mid-page).
  if (scrolledPast(window)) bar.classList.add('is-revealed');
}

// Premium scroll animations (Offer Listicle): reveal listicle items as they
// enter the viewport, and count up the stat-band numbers — both driven by a
// throttled scroll handler + getBoundingClientRect (the synchronous first
// check() reveals/counts whatever is already in view). Gated by
// prefers-reduced-motion: under reduce the head script never adds .landra-anim
// and this returns early, so items stay fully visible and stats show their
// final value. Scoped to Offer-Listicle classes (offer-reason items + the
// giant-band stat), so other templates are unaffected. Idempotent (runs inside
// the __landraInitDone guard).
function __landraPremiumAnims() {
  try {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  } catch (e) {}
  // The head script already adds .landra-anim before paint (so items start
  // hidden with no flicker); re-assert here in case that was stripped.
  document.documentElement.classList.add('landra-anim');

  var reasons = [].slice.call(
    __landraRoot.querySelectorAll('section[data-section^="offer-reason-"] .lc-or')
  );
  // Only the premium giant-band stat (.lc-sr-band-v) counts up — NOT the
  // standard .lc-sr-v, which appears on every template and would otherwise make
  // existing advertorials/blogs flash-then-count their numbers on load.
  var stats = [].slice.call(__landraRoot.querySelectorAll('.lc-sr-band-v'));
  if (!reasons.length && !stats.length) return;

  // Scroll-driven reveal/count-up via getBoundingClientRect — deliberately NOT
  // IntersectionObserver: the synchronous first check() reveals/counts anything
  // already in view immediately, so content can never get stuck hidden if an
  // async observer never fires. Each element is handled once, then dropped.
  // getBoundingClientRect is viewport-relative, so it stays correct no matter
  // which element scrolls — the scroll listener below is capture-phase so window
  // also receives scroll from a popup/iframe's own inner container.
  function inView(el, frac) {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var r = el.getBoundingClientRect();
    return r.top < vh * frac && r.bottom > 0;
  }
  function check() {
    reasons = reasons.filter(function (el) {
      if (inView(el, 0.92)) {
        el.classList.add('lc-in');
        return false;
      }
      return true;
    });
    stats = stats.filter(function (el) {
      if (inView(el, 0.85)) {
        __landraCountUp(el);
        return false;
      }
      return true;
    });
    if (!reasons.length && !stats.length) {
      window.removeEventListener('scroll', onScroll, true);
      window.removeEventListener('resize', onScroll);
    }
  }
  // Leading + trailing time-based throttle (NOT requestAnimationFrame, so reveal
  // still fires where rAF is stalled — background tabs, some automation). The
  // trailing call guarantees an item that scrolls into view in the final burst
  // before the user stops is still revealed without needing another scroll.
  var last = 0;
  var trailing = null;
  function run() {
    last = Date.now();
    trailing = null;
    check();
  }
  function onScroll() {
    var remaining = 80 - (Date.now() - last);
    if (remaining <= 0) {
      if (trailing) {
        clearTimeout(trailing);
        trailing = null;
      }
      run();
    } else if (!trailing) {
      trailing = setTimeout(run, remaining);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', onScroll);
  check();
}

// Count a stat number up from 0 to its value, preserving any prefix/suffix
// (e.g. dollar sign, percent) and the original comma/decimal formatting.
// Parsing is done with char codes (no d / B regex) — this whole module is a
// template literal, where backslash escapes get mangled (see header note).
function __landraCountUp(el) {
  var raw = (el.textContent || '').trim();
  // Locate the numeric span: first digit, extended over digits, commas and dots.
  var start = -1;
  var end = -1;
  for (var i = 0; i < raw.length; i++) {
    var code = raw.charCodeAt(i);
    var isDigit = code >= 48 && code <= 57;
    if (isDigit) {
      if (start === -1) start = i;
      end = i + 1;
    } else if (start !== -1 && (raw.charAt(i) === ',' || raw.charAt(i) === '.')) {
      end = i + 1;
    } else if (start !== -1) {
      break;
    }
  }
  if (start === -1) return;
  var numStr = raw.slice(start, end);
  // Drop any trailing comma/dot the span over-captured.
  while (numStr.length && (numStr.charAt(numStr.length - 1) === ',' || numStr.charAt(numStr.length - 1) === '.')) {
    numStr = numStr.slice(0, -1);
  }
  if (!numStr) return;
  var prefix = raw.slice(0, start);
  var suffix = raw.slice(start + numStr.length);
  var hasComma = numStr.indexOf(',') !== -1;
  var dotIdx = numStr.indexOf('.');
  var decimals = dotIdx === -1 ? 0 : numStr.length - dotIdx - 1;
  var target = parseFloat(numStr.split(',').join(''));
  if (!isFinite(target)) return;
  function group(intStr) {
    var out = '';
    var n = 0;
    for (var j = intStr.length - 1; j >= 0; j--) {
      out = intStr.charAt(j) + out;
      n++;
      if (n % 3 === 0 && j > 0) out = ',' + out;
    }
    return out;
  }
  function fmt(v) {
    var s = v.toFixed(decimals);
    if (hasComma) {
      var parts = s.split('.');
      parts[0] = group(parts[0]);
      s = parts.join('.');
    }
    return prefix + s + suffix;
  }
  var dur = 1100;
  var t0 = window.performance && performance.now ? performance.now() : Date.now();
  function step(now) {
    var t = Math.min(1, ((now || Date.now()) - t0) / dur);
    var eased = 1 - Math.pow(1 - t, 3);
    el.textContent = fmt(target * eased);
    if (t < 1) requestAnimationFrame(step);
    else el.textContent = raw;
  }
  requestAnimationFrame(step);
}

// Forward the landing URL's query params (utm_*, tw_*, and anything else) onto
// every on-page link, so Facebook / Triple-Whale ad attribution survives the
// click through to the product page and checkout. Shopify serves the page, so
// the params land in the URL on arrival; without this they die on the first
// CTA click because every CTA href is hard-coded. Merges — never clobbers a
// param a link already carries (e.g. a permalink's variant=). Runs inside the
// __landraInitDone guard so a double-included bundle never double-decorates.
function __landraForwardParams() {
  var search = window.location.search;
  if (!search || search === '?') return;
  var incoming = new URLSearchParams(search);
  Array.prototype.forEach.call(__landraRoot.querySelectorAll('a[href]'), function(a) {
    var raw = a.getAttribute('href');
    if (!raw) return;
    // Same-page anchors and non-navigation schemes have nothing to attribute.
    if (raw.charAt(0) === '#') return;
    var lower = raw.toLowerCase();
    if (lower.indexOf('mailto:') === 0 || lower.indexOf('tel:') === 0 || lower.indexOf('javascript:') === 0) return;
    var url;
    // a.href (IDL) resolves relative hrefs against the page; new URL parses it.
    try { url = new URL(a.href); } catch (e) { return; }
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return;
    var changed = false;
    incoming.forEach(function(value, key) {
      if (!url.searchParams.has(key)) { url.searchParams.set(key, value); changed = true; }
    });
    if (changed) a.setAttribute('href', url.toString());
  });
}

// When the announcement bar is sticky, anything else that pins to the top
// (the rail sidebar offer card pins at top:24px) must drop below it. Publish
// the bar's measured height as --landra-an-h on the root element; the rail
// CSS adds it to the sidebar's sticky top. Reads the COMPUTED position so the
// Overlay/Split sticky-disable rule (position:static) yields a 0 offset, and
// re-measures on resize (the bar's height changes across breakpoints).
function __landraStickyBarOffset() {
  var bar = __landraRoot.querySelector('[data-section="announcement"]');
  if (!bar || !bar.querySelector('.lc-an-sticky')) return;
  function measure() {
    var stuck = getComputedStyle(bar).position === 'sticky';
    document.documentElement.style.setProperty(
      '--landra-an-h',
      stuck ? bar.getBoundingClientRect().height + 'px' : '0px'
    );
  }
  measure();
  window.addEventListener('resize', measure);

}

// Announcement-bar countdown. Runs inside the __landraInitDone guard, so a
// double-included script never starts two intervals on the same timer.
function __landraCountdown() {
  __landraRoot.querySelectorAll('.lc-an-timer[data-countdown-mode]').forEach(function(timer) {
    var mode = timer.getAttribute('data-countdown-mode');
    var deadline = NaN;
    var durationMs = 0;
    var storageKey = '';
    if (mode === 'evergreen') {
      var durationSec = parseFloat(timer.getAttribute('data-countdown-seconds') || '');
      if (!(durationSec > 0)) { timer.classList.add('lc-an-t-done'); return; }
      durationMs = durationSec * 1000;
      storageKey = 'landra-cd:' + location.pathname + ':' + durationSec;
      var stored = NaN;
      // localStorage can throw (Safari private mode) — fall back to an
      // in-memory deadline so the timer still ticks for this page view.
      try { stored = parseInt(localStorage.getItem(storageKey) || '', 10); } catch (e) {}
      if (!(stored > Date.now())) {
        stored = Date.now() + durationMs;
        try { localStorage.setItem(storageKey, String(stored)); } catch (e) {}
      }
      deadline = stored;
    } else {
      // datetime-local string (no timezone) parses as the visitor's local
      // time — the promo "ends at 11:59pm" in every visitor's timezone.
      deadline = new Date(timer.getAttribute('data-countdown-end') || '').getTime();
    }
    if (!isFinite(deadline)) { timer.classList.add('lc-an-t-done'); return; }
    var dEl = timer.querySelector('[data-cd-d]');
    var hEl = timer.querySelector('[data-cd-h]');
    var mEl = timer.querySelector('[data-cd-m]');
    var sEl = timer.querySelector('[data-cd-s]');
    if (!hEl || !mEl || !sEl) return;
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    var intervalId = 0;
    function tick() {
      var secs = Math.floor((deadline - Date.now()) / 1000);
      if (secs <= 0) {
        if (mode === 'evergreen') {
          deadline = Date.now() + durationMs;
          try { localStorage.setItem(storageKey, String(deadline)); } catch (e) {}
          secs = Math.floor((deadline - Date.now()) / 1000);
        } else {
          // Expired fixed timer: hide the digits, keep the bar + promo text.
          timer.classList.add('lc-an-t-done');
          if (intervalId) clearInterval(intervalId);
          return;
        }
      }
      // The Days cell appears only when >= 1 day remains; hours then wrap at
      // 24. Below a day (or on markup without a days cell), hours carry the
      // full remaining count so nothing is lost.
      var days = Math.floor(secs / 86400);
      if (dEl && days > 0) {
        timer.classList.add('lc-an-t-show-days');
        dEl.textContent = pad(days);
        hEl.textContent = pad(Math.floor(secs / 3600) % 24);
      } else {
        timer.classList.remove('lc-an-t-show-days');
        hEl.textContent = pad(Math.floor(secs / 3600));
      }
      mEl.textContent = pad(Math.floor(secs / 60) % 60);
      sEl.textContent = pad(secs % 60);
    }
    // Run once synchronously so an already-expired fixed timer never flashes.
    tick();
    if (!timer.classList.contains('lc-an-t-done')) {
      intervalId = setInterval(tick, 1000);
    }
  });
}
// Run on DOMContentLoaded when the document is still parsing; otherwise (e.g.
// pasted into an already-loaded host page) DOMContentLoaded has fired and would
// never call back, leaving .fade-in content stuck at opacity:0 — so run now.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', __landraInit);
} else {
  __landraInit();
}
})();
